export default __webpack_public_path__ + "static/media/img_employee_tip6.78dcf33d.png";